export function initializeStencil(service) {
  const { stencilService, paperScroller, snaplines } = service;
  stencilService.create(paperScroller, snaplines, service.readOnly);
  stencilService.setShapes();

  if (!service.readOnly) {
    stencilService.stencil.on({
      'element:dragstart': () => service.tooltip.disable(),
      'element:dragend': () => service.tooltip.enable(),
    });
  }
}
